module.exports = __webpack_public_path__ + "static/media/post11.ab0b22e9.PNG";